import { Event } from "../../../types/event";
import { MenuItem } from "../../../types/menu";
import { Vendor } from "../../../types/vendor";
import {OrderAheadItem, OrderAheadLocation} from "../../../types/orderAhead";
import {Transaction} from "../../../types/transaction";

// DB values of orders_order_ahead.status: "processed" normally, "refund" after
// a partial refund, "voided" after a full refund (set by api/refund_order_ahead.js).
export const ORDER_AHEAD_STATUS_OPTIONS = [
  { value: "processed", label: "Processed" },
  { value: "refund", label: "Refunded" },
  { value: "voided", label: "Voided" },
] as const;

export const orderAheadStatusLabel = (status?: string) =>
  ORDER_AHEAD_STATUS_OPTIONS.find((o) => o.value === status)?.label ??
  (status ? status.charAt(0).toUpperCase() + status.slice(1) : "—");

export enum TaxType {
  TAXED = "taxed",
  INCLUSIVE = "inclusive",
  EXCLUSIVE = "exclusive",
  NO_TAX = "no_tax",
}

export interface Item {
  id: number;
  price: number;
  tags: string[];
  description?: string;
  short_name?: string;
  upc: string;
  image?: string;
  is_active?: boolean;
  created_at: string;
  updated_at: string;
  name: string;
  event_id: number;
  event?: Event;
  menu_items: MenuItem[];
  token_price: number;
  redeemable_token_id?: string;
  redeemable_token_name?: string;
  taxable_item?: boolean;
  tax: TaxType;
  tax_percentage: number;
  quantity?: number;
  vendor?: Vendor;
  vendor_id?: number;
  modifier_type?: string;
  modifiers: ItemModifiers[];
  sales_limit?: number;
  order_quantity_limit?: number;
}

export interface ItemModifiers {
  id: number;
  name: string;
  additional_price: number;
  type: string;
  sub_type: string;
  is_active?: boolean;
  created_at: string;
  updated_at: string;
  organization_id: number;
}


export interface CartItem extends Item {
  quantity: number;
}

export interface OrderAheadOrder {
  id: number;
  reference_id: string;
  email: string;
  phone_number: string;
  processor_ref_id: string;
  subtotal: number;
  eventName: string;
  eventId: number;
  eventDynamicDescriptor: string;
  eventSurchargePercentage: number;
  transaction_at: string;
  status: string;
  expo_status: string;
  digital_surcharge: number;
  tax: number;
  tip: number;
  items: OrderAheadItem[];
  event: Event;
  vendor: Vendor;
  location: OrderAheadLocation;
  transactions: Transaction[];
  transaction_total: number;
  promo_code_uid: string;
  promo_code_description: string;
  total_promo_amount: number;
  tip_amount?: number;
  created_at: string;
  updated_at: string;
  tip_type?: 'percentage' | 'custom' | 'none';
}
